import { GridTemplateValue } from '@billy/design-system'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { AVERAGE_COLUMN_WIDTH, INVOICE_LINE_COLUMNS_WIDTHS } from '../constants/invoiceLineColumnWidths'

export const getInvoiceLineColumnWidth = (column: InvoiceLineColumn): GridTemplateValue =>
  INVOICE_LINE_COLUMNS_WIDTHS[column] || AVERAGE_COLUMN_WIDTH
